const AdminRoutes = [
    {
        path: 'resourceManage',
        name: 'resourceManage',
        component: () => import ('@/views/Admin/resourceManage'),
        meta: {
            title: 'resourceManage'
        }
    },
    {
        path: 'userManage',
        name: 'userManage',
        component: () => import ('@/views/Admin/userManage'),
        meta: {
            title: 'userManage'
        }
    },
    {
        path: 'roleManage',
        name: 'roleManage',
        component: () => import ('@/views/Admin/roleManage'),
        meta: {
            title: 'roleManage'
        }
    },
    {
        path: 'dataManage',
        name: 'dataManage',
        component: () => import ('@/views/Admin/dataPermManage'),
        meta: {
            title: 'dataPermission'
        }
    },
    {
        path: 'dictionary',
        name: 'dictionary',
        component: () => import ('@/views/Admin/dictionary'),
        meta: {
            title: '数据字典'
        }
    },
    {
        path: 'dictdetails',
        name: 'dictdetails',
        component: () => import ('@/views/Admin/dictdetails'),
        meta: {
            title: '数据字典'
        }
    },
    {
        path: 'mail',
        name: 'mail',
        component: () => import ('@/views/Admin/mail'),
        meta: {
            title: '邮件模板'
        }
    },
    {
        path: 'systemTools',
        name: 'systemTools',
        mate: { title: '工具管理' },
        component: () => import ('@/views/Admin/tools/index'), // 工具管理
        children: [
            {
                path: 'scheduledTask',
                name: 'scheduledTask',
                component: () => import('@/views/Admin/tools/scheduledTask'), // 定时任务
                meta: {
                    title: '定时任务'
                }
            },
            {
                path: 'taskLog',
                name: 'taskLog',
                component: () => import('@/views/Admin/tools/taskLog'), // 任务日志
                meta: {
                    title: '任务日志'
                }
            },
        ]
    },
    
]

export default AdminRoutes